import { memo } from "react";

import type { SiteControllerSetting_SettingPageQuery } from "@/lib/gql/__generated__/graphql";
import { SiteControllerType } from "@/lib/gql/__generated__/graphql";

import { useTransitionBlock } from "@/hooks/use-transition-block";

import {
	SettingsSiteControllerAirHost,
	SettingsSiteControllerBeds24,
	SettingsSiteControllerNeppan,
	SettingsSiteControllerNotSelected,
	SettingsSiteControllerNotUsing,
	SettingsSiteControllerTemairazu,
	SettingsSiteControllerTLLincoln,
} from "./components";
import * as UseCase from "../model/base/use-case";

type Props = {
	data: SiteControllerSetting_SettingPageQuery;
};

export const SettingsSiteControllerPresenter = memo(({ data }: Props) => {
	const { viewModel, onSetViewModel, resetViewModel, siteControllerSettingBaseFormModelMethods, queryData } =
		UseCase.useInitialized({ data });
	const { siteControllerType } = viewModel;

	useTransitionBlock(viewModel.isDirty);

	return (
		<>
			{/* 未選択 */}
			{siteControllerType.value === "未選択" && (
				<SettingsSiteControllerNotSelected
					viewModel={viewModel}
					onSetViewModel={onSetViewModel}
					siteControllerSettingBaseFormModelMethodsType={{
						siteControllerSettingBaseFormModelMethods,
					}}
				/>
			)}
			{/* CHILLNNで管理する */}
			{siteControllerType.value === SiteControllerType.NotUsing && (
				<SettingsSiteControllerNotUsing
					viewModel={viewModel}
					queryData={{ isSiteControllerRegistered: queryData.isSiteControllerRegistered }}
					onSetViewModel={onSetViewModel}
					resetViewModel={resetViewModel}
					siteControllerSettingBaseFormModelMethodsType={{
						siteControllerSettingBaseFormModelMethods,
					}}
				/>
			)}
			{/* ねっぱん */}
			{siteControllerType.value === SiteControllerType.Neppan && (
				<SettingsSiteControllerNeppan
					viewModel={viewModel}
					onSetViewModel={onSetViewModel}
					resetViewModel={resetViewModel}
					siteControllerSettingBaseFormModelMethodsType={{ siteControllerSettingBaseFormModelMethods }}
				/>
			)}
			{/* 手間いらず */}
			{siteControllerType.value === SiteControllerType.Temairazu && (
				<SettingsSiteControllerTemairazu
					viewModel={viewModel}
					onSetViewModel={onSetViewModel}
					resetViewModel={resetViewModel}
					siteControllerSettingBaseFormModelMethodsType={{ siteControllerSettingBaseFormModelMethods }}
				/>
			)}
			{/* Beds24 */}
			{siteControllerType.value === SiteControllerType.Beds24 && (
				<SettingsSiteControllerBeds24
					viewModel={viewModel}
					onSetViewModel={onSetViewModel}
					resetViewModel={resetViewModel}
					siteControllerSettingBaseFormModelMethodsType={{
						siteControllerSettingBaseFormModelMethods,
					}}
					queryData={queryData}
				/>
			)}
			{/* TL-Lincoln */}
			{siteControllerType.value === SiteControllerType.TlLincoln && (
				<SettingsSiteControllerTLLincoln
					viewModel={viewModel}
					onSetViewModel={onSetViewModel}
					resetViewModel={resetViewModel}
					siteControllerSettingBaseFormModelMethodsType={{
						siteControllerSettingBaseFormModelMethods,
					}}
					queryData={queryData}
				/>
			)}
			{/* AirHost */}
			{siteControllerType.value === SiteControllerType.AirHost && (
				<SettingsSiteControllerAirHost
					viewModel={viewModel}
					onSetViewModel={onSetViewModel}
					resetViewModel={resetViewModel}
					siteControllerSettingBaseFormModelMethodsType={{
						siteControllerSettingBaseFormModelMethods,
					}}
					queryData={queryData}
				/>
			)}
		</>
	);
});

SettingsSiteControllerPresenter.displayName = "SettingsSiteControllerPresenter";
